export const storeModule = {
  address: "店鋪住所",
  baseInfo: "基本情報",
  content: "內容",
  time: "營業時間",
  dateTime: "營業日",
  pickTime: "自提時間",
  devTime: "外賣時間",
  payFun: "支付方式",
  detail: "店鋪詳情",
  detailInfo: "店铺详细",
  devPrice: "配送費",
  minPrice: "最低消費金額",
  freePrice: "* 以上免配送費",
  freeDevPriceDiff: "还差*免配送费",
  freeDevPrice: "免配送費",
  leal: "特商法",
  lealTab1: "项目",
  lealTab2: "计入栏",
  lealTitle1: "商家名称(公司名、商号、店名)",
  lealTitle2: "商家地址",
  lealTitle3: "代表人或经营责任人",
  lealTitle4: "代表人或经营责任人(假名)",
  lealTitle5: "联系地址/官网",
  lealTitle6: "联系地址/邮箱",
  lealTitle7: "联系地址/电话",
  lealTitle8: "商品价格区间",
  lealTitle9: "交货时间、发货方式",
  lealTitle10: "支付时间和支付方式",
  lealTitle11: "除商品价格之外的必须费用/配送费、手续费、消费税等",
  lealTitle12: "退货的条件/退货期限、退货时产生的配送费或中途解约、退会的条件",
  lealTitle13: "瑕疵品的处理办法",
  shopTimeOuter1: "受理中止",
  shopTimeOuter2: "不在受理时间内",
  shopTimeOuterSm1: "準備中",//休止中
  shopTimeOuterSm2: "时间外",
  orderSm1: "可预约",
  orderDayBefore: "*天前",
  noText: "无",
  storeRemark: "店鋪一言",
  devDistanceNo: "目前的配送地址不在店鋪配送範圍內。請選擇其他店鋪",
  devSearch: "搜索",
  devNoAddress: "請設置配送地址"
};
export const evaluationModule = {
  star: "滿足度",
  contentHolder: "請留言",
  noStar: "請選擇滿意度",
  noContent: "評論內容不能為空",
  submitSuccess: "評價成功",
  replay: "商家回復",
  uploadSuccess: "上傳成功"
};
